import CONSTANTS from '../../constants/index.js'
import { getWindowLocation } from '../../utility/index.js'

export default function getTrackingCode() {
  // console.log('xxwindow.location.host', getWindowLocation().host)
  // console.log('domainPropertyMap', CONSTANTS.domainPropertyMap)
  // console.log('domainPropertyMap.get', CONSTANTS.domainPropertyMap.get(getWindowLocation().host))
  return CONSTANTS.domainPropertyMap.get(getWindowLocation().host)
}
